/**
 * MediaModule
 * The MediaModule API description
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { MediasDto } from '../model/mediasDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class MediaService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param publicId 
     * @param resourceType 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public mediaControllerDelete(publicId: string, resourceType?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public mediaControllerDelete(publicId: string, resourceType?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public mediaControllerDelete(publicId: string, resourceType?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public mediaControllerDelete(publicId: string, resourceType?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling mediaControllerDelete.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (publicId !== undefined && publicId !== null) {
            queryParameters = queryParameters.set('publicId', <any>publicId);
        }
        if (resourceType !== undefined && resourceType !== null) {
            queryParameters = queryParameters.set('resourceType', <any>resourceType);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/media-handler/v1/media`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public mediaControllerDeleteBulk(body: MediasDto, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public mediaControllerDeleteBulk(body: MediasDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public mediaControllerDeleteBulk(body: MediasDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public mediaControllerDeleteBulk(body: MediasDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling mediaControllerDeleteBulk.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('delete',`${this.basePath}/media-handler/v1/media/bulk`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param publicId 
     * @param resourceType 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public mediaControllerGetMetadata(publicId: string, resourceType?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public mediaControllerGetMetadata(publicId: string, resourceType?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public mediaControllerGetMetadata(publicId: string, resourceType?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public mediaControllerGetMetadata(publicId: string, resourceType?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling mediaControllerGetMetadata.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (publicId !== undefined && publicId !== null) {
            queryParameters = queryParameters.set('publicId', <any>publicId);
        }
        if (resourceType !== undefined && resourceType !== null) {
            queryParameters = queryParameters.set('resourceType', <any>resourceType);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/media-handler/v1/media/metadata`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param fileName 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public mediaControllerSignature(fileName?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public mediaControllerSignature(fileName?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public mediaControllerSignature(fileName?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public mediaControllerSignature(fileName?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (fileName !== undefined && fileName !== null) {
            queryParameters = queryParameters.set('fileName', <any>fileName);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/media-handler/v1/media/signature`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
